<template>

 <text-input type="area" :rows="rows" v-html="label" :disabled="disabled" />

</template>

<script>

export default {
  name: 'text-area',

  props: {
    label: {
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    rows: {
      type: Number,
      default: 4
    }
  }

}

</script>



// WEBPACK FOOTER //
// TextArea.vue?5f51e852